import en from './en';
import pl from './pl';
import nl from './nl';

export default {
  en,
  pl,
  nl
};
